/**
 * Module for revealing the 'existing RS account customer inputs'
 */

/* eslint-disable */

module.exports = {
  init: function() {
    /* Setup the variables for the buttons and content to show hide */
    var self = this;
    self.content = $('#js-accountCustomerContent');
    self.btnOpen = $('#js-accountCustomerOpenBtn');
    self.inputs = self.content.find('input');
    self.btnActiveClass = 'active';

    /* Create event listener to open the inputs */
    self.btnOpen.on('click', function() {
      self.open();
    });

    if(self.inputs.val() !== '') {
      self.open();
    }
  },

  open: function() {
    var self = this;
    var btnClose  = $('#js-accountCustomerCloseBtn');

    self.content.slideDown(100);
    self.btnOpen.addClass(self.btnActiveClass);
    btnClose.removeClass(self.btnActiveClass);
      
    /* If the open function is triggered create the close function */
    function close() {
      self.content.addClass('in').slideUp(100);
      
      btnClose.addClass(self.btnActiveClass);
      self.btnOpen.removeClass(self.btnActiveClass);

      self.clearValidation();

      $(document).ajaxStop(function() {
        if(self.content.is(':hidden')) {
          self.clearValidation();  
        }
      });

      /* Remove the close event listener once No is clicked */
      btnClose.off('click');
    }

    /* Create the event listener only if the open function is triggered */
    btnClose.on('click', close);
  },

  clearValidation: function() {
    var self = this;

    // Hide the validation message
    self.content.find('.interactive-message-container').addClass('hidden');

    /* Find all the inputs insde the content and remove the value and any invalidation errors */
    self.inputs.each(function() {
      $(this).val('').removeClass('has-error verified').siblings('.text-error-icon, .text-verified-icon').addClass('hidden');
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/accountCustomerShowHide.js
// module id = 258
// module chunks = 4